import { render } from "./TypeSelect.vue?vue&type=template&id=20a641c4&scoped=true"
import script from "./TypeSelect.vue?vue&type=script&lang=ts"
export * from "./TypeSelect.vue?vue&type=script&lang=ts"

import "./TypeSelect.vue?vue&type=style&index=0&id=20a641c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20a641c4"

export default script